import script from "./Ccertificates.vue?vue&type=script&setup=true&lang=ts"
export * from "./Ccertificates.vue?vue&type=script&setup=true&lang=ts"

import "./Ccertificates.vue?vue&type=style&index=0&id=305954fe&scoped=true&lang=less"

import exportComponent from "/Users/neal/Desktop/www/qingtv/qingtv-back-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-305954fe"]])

export default __exports__